import { processFloorExtrusions } from "building-geometry/floors/processFloorExtrusions";
import type { Extrusion } from "geom/brep";
import { planeNewXY, planeReProjectPolyLine2 } from "geom/plane";
import type { PolyLine2 } from "geom/polyLine2Types";

export interface FloorExtrusionPolylines {
  outlines: PolyLine2[];
  openings: PolyLine2[];
}

export function floorExtrusionPolylinesNew(): FloorExtrusionPolylines {
  return {
    outlines: [],
    openings: [],
  };
}

/**
 * Converts floor extrusions (slab, subfloor, etc.) to plan-view 2D polylines.
 * Outer loops go into `outlines`, inner loops (holes) go into `openings`.
 */
export function collectPolylinesFromExtrusions(
  extrusions: readonly Extrusion[],
  result: FloorExtrusionPolylines,
): void {
  const worldXY = planeNewXY();
  const processed = processFloorExtrusions([...extrusions]);
  for (const extr of processed) {
    const { plane } = extr.profile;
    for (let li = 0; li < extr.profile.loops.length; li++) {
      const loop = extr.profile.loops[li];
      if (!loop || loop.length < 4) {
        continue;
      }
      const pl2 = planeReProjectPolyLine2(loop, plane, worldXY);
      if (li === 0) {
        result.outlines.push(pl2);
      } else {
        result.openings.push(pl2);
      }
    }
  }
}
